    'use strict';

var React = require('react');
var _ = require('lodash');
var BankAccountList = require('../Common/SpecifyBankAccountList.jsx');
var TextInput = require('../Common/TextInput.jsx');
var RadioInput = require('../Common/RadioInput.jsx');
var InlineMessage = require('../Common/InlineMessage.jsx');
var CancelDoneButtons = require('../Common/CancelDoneButtons.jsx');
var Classnames = require('classnames');

var FundingYourProductActions = require('../../actions/FundingYourProductActions.js');
var Constants = require('../../constants/FundingYourProductConstants.js');
var ApplicationConstants = require('../../constants/ApplicationConstants');
var MessageTypes = ApplicationConstants.messageTypes;


var DirectDebit = React.createClass({
    updateStoreModel: function (event) {
        var fieldId = event.target.model;
        var fieldValue = event.target.value;
        if (this.props.inSummary) {
            FundingYourProductActions.updateExistingRollover(fieldId, fieldValue, Constants.RollOverTypes.NON_ROLLOVER, this.props.index);
        } else {
            FundingYourProductActions.updateNewRollover(fieldId, fieldValue, this.props.activeFundType, Constants.RollOverTypes.NON_ROLLOVER);
        }
    },

    selectBankAccount: function (event) {
        var fieldValue = event.target.value;
        if (this.props.inSummary) {
            FundingYourProductActions.updateExistingRollover('bankAccountId', fieldValue, Constants.RollOverTypes.NON_ROLLOVER, this.props.index);
        } else {
            FundingYourProductActions.updateNewRollover('bankAccountId', fieldValue, this.props.activeFundType, Constants.RollOverTypes.NON_ROLLOVER);
        }

    },

    cancelOtherFundType: function (e) {
        this.props.onCancelClick(e);
    },

    submitOtherFundType: function (e) {
        this.props.onDoneClick(e);
    },

    render: function () {
        var hideFutureRequestText = true;
        var accountNumberError = _.filter(this.props.data.errorList, { id: 'fypBankAccountNumberText' });
        if (accountNumberError.length === 0 && this.props.data.accountNumber) {
            hideFutureRequestText = false;
        }

        var existingBankAccountList =<BankAccountList id="fypBankAccountsList"
                                                      model="bankAccountId"
                                                      tableId="fypSpecifyBankAccountTable"
                                                      data={this.props.bankAccountList}
                                                      onChange={this.selectBankAccount}
                                                      checked={this.props.data.bankAccountId}
                                                      isValid={this.props.data.hideBankAccountListValid}
                                                      label="Debit total amount from:"
                                                      errorMessage={this.props.content.fundingYourProduct.listBankAccountInline} />;
        var nominateOtherAccount =
        <div id="fypNominatedOtherAccount">
            <div id="fypNameOfAccountHolder">
                <TextInput id="fypAccountHolderNameText"
                           model="accountHolderName"
                           label={Constants.sectionLabels.accountHolderName}
                           value={this.props.data.accountHolderName}
                           className={Classnames({ 'other-fund-types-edit-mode': this.props.inSummary })}
                           onBlur={this.updateStoreModel}
                           errorList={this.props.data.errorList} />
            </div>
            <div id="fypNominatedAccountHolderOption">
                <RadioInput id="fypBankAccountHeldOption"
                            model="bankAccountHeldOption"
                            data={ApplicationConstants.YesNoRadioData}
                            value={this.props.data.bankAccountHeldOption}
                            onChange={this.updateStoreModel}
                            contextualMessage={this.props.data.showBankAccountHeldText ? this.props.content.fundingYourProduct.bankAccountHeldText :null}
                            label="Is this bank account held in the same name(s) as this application?"
                            errorList={this.props.data.errorList} />
            </div>
            <div id="fypBranchNumber">
                <TextInput id="fypBranchNumberText"
                           model="branchNumber"
                           label={Constants.sectionLabels.branchNumber}
                           className={Classnames({ 'other-fund-types-edit-mode': this.props.inSummary })}
                           onBlur={this.updateStoreModel}
                           value={this.props.data.branchNumber}
                           errorList={this.props.data.errorList} />
            </div>
            <div id="fypBankAccount">
                <TextInput id="fypBankAccountNumberText"
                           model="accountNumber"
                           label={Constants.sectionLabels.accountNumber}
                           className={Classnames({ 'other-fund-types-edit-mode': this.props.inSummary })}
                           onBlur={this.updateStoreModel}
                           value={this.props.data.accountNumber}
                           errorList={this.props.data.errorList} />
            </div>
        </div>;
        var details =
        <div>
            <InlineMessage id="fypContextualMessageDirectDebit"
                           isHidden={hideFutureRequestText}
                           type={MessageTypes.info}
                           message={this.props.futureRequestText} />
            <div id="fypStartDate">
                 <TextInput id="fypStartDateField"
                            label={Constants.sectionLabels.directDebitStartDate}
                            value={this.props.data.startDate}
                            placeholder={ApplicationConstants.DateFormat}
                            className={Classnames('form-number-input',{'other-fund-types-edit-mode': this.props.inSummary })}
                            onBlur={this.updateStoreModel}
                            model="startDate"
                            bottomText={this.props.content.fundingYourProduct.startDateText}
                            errorList={this.props.data.errorList} 
                            maxLength={10} />
            </div>
        </div>;
        var controls =
        <div id="fypDirectDebitControls">
            <CancelDoneButtons id="fypDirectDebitFormButton"
                               index={this.props.index}
                               onClickCancel={this.cancelOtherFundType}
                               onClickDone={this.submitOtherFundType} />
        </div>;
        var amountMessage = '';
        if (!this.props.data.hideDirectDebitAddedText) {
            if (this.props.product === ApplicationConstants.ProductIds.SUPER ||
                this.props.product === ApplicationConstants.ProductIds.PENSION) {
                if (this.props.activeFundType === Constants.FundingTypes.Personal_injury_payment) {
                    amountMessage = this.props.content.fundingYourProduct.personalInjuryDirectDebitAddedText;
                } else if (this.props.activeFundType === Constants.FundingTypes.CGT_contribution) {
                    amountMessage = this.props.content.fundingYourProduct.cgtDirectDebitAddedText;
                } else if (this.props.activeFundType === Constants.FundingTypes.Downsizer_contribution) {
                    amountMessage = this.props.content.fundingYourProduct.downsizerDirectDebitAddedText;
                } else {
                    amountMessage = this.props.directDebitAlreadyAddedText;
                }
            } else {
                amountMessage = this.props.directDebitAlreadyAddedText;
            }
        } else {
            if (this.props.product === ApplicationConstants.ProductIds.SUPER ||
                this.props.product === ApplicationConstants.ProductIds.PENSION) {
                if (this.props.activeFundType === Constants.FundingTypes.Personal_injury_payment) {
                    amountMessage = this.props.content.fundingYourProduct.personalInjuryDirectDebitText;
                } else if (this.props.activeFundType === Constants.FundingTypes.CGT_contribution) {
                    amountMessage = this.props.content.fundingYourProduct.cgtDirectDebitText;
                } else if (this.props.activeFundType === Constants.FundingTypes.Downsizer_contribution) {
                    amountMessage = this.props.content.fundingYourProduct.downsizerDirectDebitText;
                }
            }
        }
        var amount =
        <div id="fypDirectDebitAmount">
                <TextInput id="fypDirectDebitAmountField"
                           model="rollOverAmount"
                           label="Amount"
                           symbol="currency"
                           contextualMessage={amountMessage}
                           className={Classnames('text-input-amount',{ 'other-fund-types-edit-mode': this.props.inSummary })}
                           onBlur={this.updateStoreModel}
                           value={this.props.data.rollOverAmount}
                           errorList={this.props.data.errorList} />

        </div>;
        var showDetails = this.props.data.showDdDetails ? details : '';
        var showNominateAccount = this.props.data.showDdNominateAccount ? nominateOtherAccount : '';
        var showBankAccountList = this.props.bankAccountList.length > 0 && this.props.data.hideDirectDebitAddedText ? existingBankAccountList : '';

        var isNumberOfRolloversValid = _.filter(this.props.data.errorList, { id: 'fypMaxRolloversError' });
        var maxRolloverError = null;
        if (isNumberOfRolloversValid.length > 0 && isNumberOfRolloversValid[0]) {
            maxRolloverError =
                <InlineMessage id="fypMaxFundingSourcesError"
                               isHidden={!isNumberOfRolloversValid[0].message}
                               type={isNumberOfRolloversValid[0].type}
                               message={isNumberOfRolloversValid[0].message} />;
        }
        return (
            <div className={Classnames({ hidden: this.props.data.paymentMethod !== Constants.ContributionValues.DIRECT_D })} >
                {amount}
                {showBankAccountList}
                {showNominateAccount}
                {showDetails}
                {controls}
                {maxRolloverError}
            </div>
		);
    }
});

module.exports = DirectDebit;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/FundingYourProduct/DirectDebit.jsx